import React, { useEffect, useState } from "react";
import { Button, Dialog } from "@mui/material";
import {
  DialogContent,
  Divider,
  Stack,
  Typography,
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Text } from "./styles";
import DateField from "../../components/components/DateField";
import { Toast } from "../../components/components/Toast";
import CustomInput from "../../components/components/CustomInput";
import Repo from "../../Repository/Repo";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import { getLedgersNames } from "../../components/ledgers/ledgersNamesSlice";
import { useDispatch, useSelector } from "react-redux";

function UpdatePayment({
  onClose,
  onSuccess,
  onUpdate,
  row = null,
  banks = [],
  payments,
}) {
  console.log("row:", row);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  console.log("ldeger", ledgersNames);
  const [state, setState] = useState({
    amount: "",
    type: "",
    payer: "",
    mode: "",
    ledgerId: "",
    ledgerName: "",
    ledger: [],
  });
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(0);

  useEffect(() => {
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
  }, []);
  function formatDate(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000); // Convert seconds to milliseconds
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
}
  // Example usage

  
const updatePaymentInCashBank = async (newRow,id)=> {
  console.log('roww', row)
    let paymentInCashInHandMethod = row.type === "Cash" ? "paymentsInCashInHand" : "paymentsInBanks"
   let bankMethod = row.type === "Cash" ? "" : "bankId";
   const date = row.created_at
   const formattedDate = formatDate(date);
   console.log("formatdate",formattedDate); 
  let { data } = await Repo.banks({

  request: {
    method: paymentInCashInHandMethod,
    data: {
      company_code: row.company_code,
      ledgerId: row.ledgerId,
      to: row.receiver,
      from: state.ledgerName ? state.ledgerName : row.payer,
      credit: state.amount ? Number(state.amount) : Number(row.amount),
      debit: 0,
      description: state.detail,
      [bankMethod]:row.bankId,
      paymentUpdated: true,
      date: formattedDate,
      paymentId:row._id


    }

 

}
  })
  console.log('datttta', data)
}
  const handleInput = (e) => {
    const { name, value } = e.target;
    const selectedBank = e.target.value;
    setState((prev) => ({ ...prev, [name]: value }));
    setSelectedAccountNumber(selectedBank.accountNumber);
  };

  const handleClear = (arg) => {
    setState((prev) => ({ ...prev, [arg]: "" }));
  };

  const errorHandler = () => {
    setError(true);
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleLedger = (e, val) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      ledgerId: val._id,
      ledgerName: val.name,
      ledger: val,
    }));
    console.log("val", val);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (state.bankName === "") {
        toast.configure();
        toast.info("Please Enter Your Bank Name");
        return;
      }

      if (state.accountNumber === "") {
        toast.configure();
        toast.info("Please Enter Your Account No");
        return;
      }

      if (row) {
        // Toast("success", "Bank Updated");
        // onUpdate(state);
        // setLoading(false);

        // let paymentInCashInHandMethod =
        //   row.type === "Cash"
        //     ? "paymentsInCashInHand"
        //     : "paymentsInBanks";
        let bankMethod = row.type === "Cash" ? "" : "bankId";

        let { data } = await Repo.payment({
          request: {
            method: "updatePayment",
            data: {
              _id: row._id,
              company_code: row.company_code,
              ledgerId: row.ledgerId,
              user_id: row.user_id,
              receiver: row.receiver,
              payer: state.ledgerName ? state.ledgerName : row.payer,
              type: state.type ? state.type : row.type,
              amount: state.amount ? state.amount : row.amount,
              paymentMode: state.paymentMode,
              srNum: row.srNum,
              balance: row.balance,
              _rev:row._rev,
              [bankMethod]:row.bankId
            },
          },

          //   request: {
          //     method: "updatePayment",
          //     data: {
          //         _id: row._id,
          //         company_code:  row.company_code,
          //         ledgerId:  row.ledgerId,
          //         user_id: "naeemtest@gmail.com",
          //         receiver: "Akram Ahmed (03315617231 )",
          //         payer: "Naeem",
          //         type: "Cash",
          //         amount: "10000",
          //         paymentMode: "purchase",
          //         srNum: "acc2f7cc-48bd-4e05-9e7d-8e551f9d87ca",
          //         balance: ""
          //     }
          // }
            

        });

        setLoading(false);
        if (data.response.status.statusCode == 200) {
          const id = data.response.data["id "];

          Toast("success", "Payment  Updated Successfully");
          updatePaymentInCashBank(row,id)
          payments();
        }
        onSuccess();
      }
      //  else {
      //     let { data } = await Repo.banks({
      //       request: {
      //         method: "updateBank",
      //         data: {
      //             _id:row._id,
      //             bankName: state.bankName,
      //             accountNumber:state.accountNumber,
      //         },
      //       },
      //     });
      //     setLoading(false);
      //     if (data.response.status.statusCode == 200) {
      //       Toast("success", "Bank  Updated Successfully");
      //     }
      //     onSuccess();
      //   }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };
  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Stack width="100%">
            <Text
              sx={{
                color: "#4CAF50",
                fontSize: "15px",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              {row ? "Bank Details" : "Add New Bank"}
            </Text>
            <Divider sx={{ mt: "16px", color: "#afafaf" }} />
          </Stack>

          <Autocomplete
            autoFocus
            size="small"
            value={state.ledger}
            onChange={(e, val) => {
              handleLedger(e, val);
            }}
            fullWidth
            // defaultValue={row.payer}
            getOptionLabel={(option) => option?.name || ""}
            options={ledgersNames}
            renderInput={(params) => (
              <TextField autoFocus {...params} label="Select Payer" />
            )}
          />

          <FormControl fullWidth size="small">
            <InputLabel>Select Transaction Mode</InputLabel>
            <Select
              name="type"
              value={state.type}
              label="Select Transaction Mode"
              onChange={handleInput}
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Bank">Bank</MenuItem>
            </Select>
          </FormControl>

          {state.type == "Bank" && (
            <FormControl fullWidth size="small">
              <InputLabel>Bank Name</InputLabel>
              <Select
                size="small"
                name="depositTo"
                value={state.depositTo}
                label="Bank Name"
                onChange={handleInput}
              >
                {banks.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item}>
                      {item.bankName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}

          {state.type == "Bank" && (
            <CustomInput
              name="amount"
              type="number"
              disabled={true}
              value={selectedAccountNumber}
            ></CustomInput>
          )}

          <CustomInput
            name="amount"
            label="Amount"
            value={state.amount}
            onChange={handleInput}
            onClear={() => handleClear("amount")}
          />

          {loading && (
            <Stack alignItems="center" width="100%" justifyContent="center">
              <ClipLoader size={35} loading={true} color="#4eaf51" />
            </Stack>
          )}
          {!loading && (
            <Stack direction="row" width="100%" justifyContent="space-evenly">
              <Button
                variant="contained"
                sx={{
                  background: "#F2F2F2 !important",
                  color: "#767676",
                  textTransform: "none",
                }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={handleSubmit}
              >
                {row ? "Update" : "Add Bank"}
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default UpdatePayment;
